import { forwardRef, type ReactNode, type TextareaHTMLAttributes } from "react";

import { cn } from "../../lib/utils";
import { Field } from "./field";

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  autoResize?: boolean;
  description?: ReactNode;
  error?: ReactNode;
  label?: ReactNode;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea(
    { autoResize = false, className, description, error, id, label, ...props },
    ref,
  ) {
    return (
      <Field
        description={description}
        error={error}
        htmlFor={id}
        label={label}
        required={props.required}
      >
        <textarea
          ref={ref}
          className={cn(
            "field-shell min-h-32 w-full resize-y px-4 py-3 text-sm outline-none placeholder:text-muted-foreground",
            autoResize && "resize-none overflow-hidden",
            Boolean(error) && "border-destructive ring-2 ring-destructive/10",
            className,
          )}
          data-slot="interactive-control"
          id={id}
          {...props}
        />
      </Field>
    );
  },
);
